import type { FC } from 'react';

import ClaimsSettingsCarrierInformationForm from './claims-settings-carrier-information-form';

interface ClaimsSettingsTabProps {
  carrierKey?: number;
}

const ClaimsSettingsTab: FC<ClaimsSettingsTabProps> = ({ carrierKey }) => {
  return (
    <div className="h-100">
      <div className="pb-10">
        <ClaimsSettingsCarrierInformationForm carrierKey={carrierKey} />
      </div>
    </div>
  );
};

export default ClaimsSettingsTab;
